import { FormattedText } from "@tm/static";
import { usePlanType } from "@tm/ui";
import { useCallback, useEffect } from "react";
import { trackListingView } from "../../trackingUtils";
import {
  Icon,
  SwitchThumb,
  SwitchTrack,
  TextContent,
  Wrapper,
} from "./AmtAttach.styles";
import { IAmtAttachProps } from "./types";

const AmtAttach = ({
  title,
  icon,
  bgBanner,
  enabled = false,
  onToggle,
  pageTracked,
}: IAmtAttachProps) => {
  const { type } = usePlanType();

  useEffect(() => {
    if (!pageTracked || !title) return;
    trackListingView("AMT_banner_shown", type);
  }, [pageTracked, title, type]);

  const handleToggle = useCallback(() => {
    onToggle?.(!enabled);
  }, [enabled, onToggle]);

  if (!title) return null;

  return (
    <Wrapper $bgBanner={bgBanner}>
      {icon && <Icon src={icon} alt="" />}
      <TextContent>
        <FormattedText value={title} />
      </TextContent>
      <SwitchTrack
        $enabled={enabled}
        onClick={handleToggle}
        type="button"
        aria-label="Toggle annual multi-trip"
      >
        <SwitchThumb $enabled={enabled} />
      </SwitchTrack>
    </Wrapper>
  );
};

export default AmtAttach;
